import React from "react";
//
import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

//
import theme from "@/foundation/Theme";
//
import { PinkBox, TopBox, Wrapper, WrapperContainer } from "./style";
import { DynamicContentHtml } from "../TopSection/style";
//
function PinkBoxComponent({ data = {}, width }) {
  return (
    data?.benefits?.benefits?.length > 0 && (
      <Wrapper>
        <WrapperContainer flexDirection={"column"}>
          <PinkBox>
            <TopBox>
              <FlexDiv
                p={width <= 992 ? "8px 24px" : "8px 18px"}
                mr={width <= 992 ? "0px" : "16px"}
                mb={width <= 992 ? "16px" : "0px"}
                alignItems={"center"}
                width={width <= 992 ? "unset" : "296px"}
                justifyContent={width >= 992 ? "center" : "flex-start"}
              >
                <StyledSvgSprite
                  icon={"icon-Shyft_Logo"}
                  height={width >= 992 ? "56px" : "48px"}
                  width={width >= 992 ? "121px" : "111px"}
                />
              </FlexDiv>
              <DynamicContentHtml
                flex={1}
                variant={"heading4"}
                p={width >= 992 ? "0px 56px" : "0 24px"}
                color={theme.colorsV2.blueGray.shade_800}
                dangerouslySetInnerHTML={{
                  __html: data?.benefits?.title,
                }}
              />
            </TopBox>
            {/* <CardsWrapper width={"100%"}>
              {data?.benefits?.benefits?.map((item, i) => {
                return (
                  <CardBox key={i} flexDirection={"column"}>
                    <FlexDiv mb={"8px"}>
                      <ImageBox>
                        <Image src={item.icon} />
                      </ImageBox>
                    </FlexDiv>
                    <Typography
                      color={theme.colorsV2.indigo.shade_600}
                      variant="heading4"
                      mb={2}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      color={theme.colorsV2.indigo.shade_600}
                      variant={"label2"}
                    >
                      {item.subtitle}
                    </Typography>
                  </CardBox>
                );
              })}
            </CardsWrapper> */}
          </PinkBox>
        </WrapperContainer>
      </Wrapper>
    )
  );
}

export default PinkBoxComponent;
